import { render } from "./Adminjobs.vue?vue&type=template&id=6692ae30&scoped=true"
import script from "./Adminjobs.vue?vue&type=script&lang=js"
export * from "./Adminjobs.vue?vue&type=script&lang=js"

import "./Adminjobs.vue?vue&type=style&index=0&id=6692ae30&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6692ae30"]])

export default __exports__